import { request } from '../api/http';

export type MediaKind = 'image' | 'audio' | 'video';

function tokenFromStorage() {
  try {
    return (
      window.localStorage.getItem('intimsync.access_token') ||
      window.localStorage.getItem('access_token') ||
      ''
    );
  } catch {
    return '';
  }
}

export async function requestMediaUploadSlot(payload: {
  mediaId: string;
  conversationId: string;
  mediaKind: MediaKind;
  mimeType: string;
  sizeBytes: number;
}) {
  return request('/messages/media-e2ee/upload-slot', {
    method: 'POST',
    auth: true,
    body: payload,
  });
}

export async function uploadEncryptedMediaBlob(mediaId: string, body: Blob | ArrayBuffer | Uint8Array) {
  const token = tokenFromStorage();
  const res = await fetch(`/api/v1/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/octet-stream',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body as any,
  });

  if (!res.ok) {
    throw new Error(`blob_upload_failed:${res.status}`);
  }
  return res.json();
}

export async function createMediaManifest(payload: {
  mediaId: string;
  conversationId: string;
  recipientUserId?: string | number | null;
  mediaKind: MediaKind;
  mimeType: string;
  sizeBytes: number;
  manifestJson: any;
  previewObjectKey?: string | null;
}) {
  return request('/messages/media-e2ee/manifest', {
    method: 'POST',
    auth: true,
    body: payload,
  });
}

export async function listMediaManifests(conversationId: string) {
  return request(`/messages/media-e2ee?conversationId=${encodeURIComponent(conversationId)}`, {
    method: 'GET',
    auth: true,
  });
}

export async function downloadEncryptedMediaBlob(mediaId: string) {
  const token = tokenFromStorage();
  const res = await fetch(`/api/v1/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!res.ok) throw new Error(`blob_download_failed:${res.status}`);
  return res.arrayBuffer();
}

export async function acknowledgeMediaBlob(mediaId: string) {
  return request(`/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}/ack`, {
    method: 'POST',
    auth: true,
    body: {},
  });
}

export async function markEncryptedMediaCached(
  mediaId: string,
  payload: {
    deviceId: string;
    client?: string;
    storageKind?: string;
    verifiedSha256?: string | null;
  }
) {
  return request(`/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}/cached`, {
    method: 'POST',
    auth: true,
    body: {
      deviceId: payload.deviceId,
      device_id: payload.deviceId,
      client: payload.client || 'web',
      storageKind: payload.storageKind || 'indexeddb',
      storage_kind: payload.storageKind || 'indexeddb',
      verifiedSha256: payload.verifiedSha256 || null,
      verified_sha256: payload.verifiedSha256 || null,
    },
  });
}

export async function startViewOnceMedia(mediaId: string) {
  return request(`/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}/view-start`, {
    method: 'POST',
    auth: true,
    body: {},
  });
}

export async function completeViewOnceMedia(mediaId: string, body?: any) {
  return request(`/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}/view-complete`, {
    method: 'POST',
    auth: true,
    body: body || {},
  });
}

export async function getEncryptedMediaBlobStatus(mediaId: string) {
  return request(`/messages/media-e2ee/blob/${encodeURIComponent(mediaId)}/status`, {
    method: 'GET',
    auth: true,
  });
}
